import { m } from 'framer-motion';
import { Link } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container } from '@mui/material';
// components
import Page from '../components/Page';
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { MaintenanceIllustration } from '../assets';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  /*   minHeight: '100vh', */
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function PageError({ haveError }) {
  return (
    <Page title="SIPTEL">
      <Container component={MotionContainer}>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
          <m.div variants={varBounce().in}>
            <Typography color="primary" variant="h4" paragraph>
              Disculpe, hubo un error.
            </Typography>
          </m.div>
          <m.div variants={varBounce().in}>
            <Typography color="primary" variant="h6" paragraph>
              Estamos trabajando para solucionarlo.
            </Typography>
          </m.div>
          <m.div variants={varBounce().in}>
            <MaintenanceIllustration
              sx={{ height: 260, my: { xs: 5, sm: 5 } }}
            />
          </m.div>

          <Button
            onClick={() => window.location.reload(false)}
            size="large"
            variant="contained"
          >
            Inicio
          </Button>

          {/*  <Link to="/dashboard">
            <Button
              size="large"
              variant="contained"      
              >
              Inicio
            </Button>
          </Link>
           */}
        </ContentStyle>
      </Container>
    </Page>
  );
}
